import { render } from "./BulkPendingOffer.vue?vue&type=template&id=7bcacbb8&scoped=true"
import script from "./BulkPendingOffer.vue?vue&type=script&lang=js"
export * from "./BulkPendingOffer.vue?vue&type=script&lang=js"

import "./BulkPendingOffer.vue?vue&type=style&index=0&id=7bcacbb8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7bcacbb8"

export default script